import React from "react";

interface EmptyStateProps {
  children: React.ReactNode;
}

/**
 * The "nothing here yet" block shared by the Overview cards.
 *
 * Deliberately quiet: an empty Overview card means the project simply hasn't got
 * there yet, which is not a problem state and shouldn't look like one.
 */
const EmptyState: React.FC<EmptyStateProps> = ({ children }) => (
  <p className="px-4 py-6 text-center text-xs text-muted-foreground">
    {children}
  </p>
);

export default EmptyState;
